import { useTranslation } from 'react-i18next';

export const StatusSelectQuiz = ({ value }) => {
    const { t } = useTranslation();
    return value ? t('quiz.published') : t('quiz.notPublished');
};
